import { render, staticRenderFns } from "./InventoryBalance.vue?vue&type=template&id=17bd2dfe&scoped=true"
import script from "./InventoryBalance.vue?vue&type=script&lang=js"
export * from "./InventoryBalance.vue?vue&type=script&lang=js"
import style0 from "./InventoryBalance.vue?vue&type=style&index=0&id=17bd2dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bd2dfe",
  null
  
)

export default component.exports